import config from '@/config'
import { symcrypt, symDecrypt } from '@/helpers/aes'

const { AES_FRONTEND_KEY } = config


export function acoToAES(object) {
  let stringified = JSON.stringify(object)
  let { encrypted, iv } = symcrypt(stringified, AES_FRONTEND_KEY)
  let data = encrypted + ':::' + iv.toString('hex')
  return data
}

export function aesToAco(s) {
  let split = s.split(':::')
  let encrypted = split[0]
  let iv = split[1]
  let decrypted = symDecrypt(AES_FRONTEND_KEY, iv, encrypted)
  let object = JSON.parse(decrypted)
  return object
}

export function validateObject(obj) {
  // validate that the object has the folllowing properties
  // shipping
  // billing
  // card
  //email
  if (!obj) return false
  console.log(`validating object`, obj)
  let valid = true
  if (!obj.billing) valid = false
  if (!obj.shipping) valid = false
  if (!obj.shipping.address1) valid = false
  if (!obj.shipping.city) valid = false
  if (!obj.shipping.state) valid = false
  if (!obj.shipping.zip) valid = false
  if (!obj.shipping.firstName) valid = false
  if (!obj.shipping.lastName) valid = false
  if (!obj.card) valid = false
  if (!obj.card.number || !obj.card.code || !obj.card.month || !obj.card.year) valid = false
  var re = new RegExp(' ', 'g');
  if (obj.card.number.indexOf(' ') != -1) {
    obj.card.number = obj.card.number.replace(re, '')
  }
  if (!obj.email) valid = false
  if (!obj.phone) valid = false
  return valid
}